/**
 * Generates a unique job number in format: JOB-YYYYMMDD-XXXXXX
 * Uses a random number to ensure uniqueness across users/sessions
 * @returns {string}
 */
export const generateJobNumber = () => {
    const now = new Date();
    const dateStr = now.getFullYear() +
        String(now.getMonth() + 1).padStart(2, '0') +
        String(now.getDate()).padStart(2, '0');

    // Generate a random 6-digit number to ensure uniqueness across different users/devices
    const randomNum = Math.floor(100000 + Math.random() * 900000);
    return `JOB-${dateStr}-${randomNum}`;
};
